import { useMemo } from 'react';
import { getActivePlayersInBlackjack } from '@utils/utils';
import Toggler from './toggler';
import useReduxState from '@hooks/useReduxState';
import styles from './heading.module.scss';
import GameHistory from '@components/game-history';
import GameFee from '@components/game-fee';
import GameFairness from '@components/game-fairness';

const LobbyHeading = (): JSX.Element => {
    const [state] = useReduxState((state) => state);
    const rooms = state.blackjackLobby.rooms;
    const blackjackStatistics = state.userData.statistics.blackjack;

    const activePlayersInRooms = useMemo(
        () => getActivePlayersInBlackjack(rooms),
        [rooms],
    );

    return (
        <section className={styles.heading}>
            <div className={styles.game}>
                <h2>Game</h2>
                <p>
                    {activePlayersInRooms} player
                    {activePlayersInRooms > 1 && 's'} in-game
                    <span />
                </p>
            </div>
            <div className={styles.actions}>
                <section className={styles.actions__btnGroup}>
                    <GameHistory stats={blackjackStatistics} />
                    <GameFee percentage={2} />
                    <GameFairness />
                </section>
                <section className={styles.actions__filter}>
                    <Toggler onClick={() => console.log('toggle')} />
                    <span>Hide {'>'}$2 Games</span>
                </section>
            </div>
        </section>
    );
};
export default LobbyHeading;
